<form [formGroup]="searchForm" [ngStyle]="getBackgroundStyle()" (ngSubmit)="execSearch()"
  class="uk-padding">
  <div class="uk-container uk-align-center">
    <div class="uk-grid">
      <div class="uk-width-1-2 uk-margin-bottom search-bloc-responsive">
        <input kendoTextBox formControlName="searchText" class="full-size"
          [placeholder]="'Rechercher une formation'" />
      </div>
      <div class="uk-width-2-5 uk-margin-bottom search-bloc-responsive">
        <ags-kendo-dropdown-treeview [data]="listDomaine" [textFielName]="'libelle'"
          [childrenListName]="'children'" [(value)]="domaineSelected" class="full-size">
        </ags-kendo-dropdown-treeview>
      </div>
      <div class="uk-width-expand uk-margin-bottom search-responsive">
          <button kendoButton class="colored-text full-size" [primary]="true" [icon]="'search'"></button>
      </div>
    </div>
    <ng-container *ngIf="advancedMode">
      <div class="uk-grid">
        <div class="uk-width-1-2 search-bloc-responsive uk-margin-bottom">
          <kendo-dropdownlist class="full-size" [data]="listModalite" [textField]="'libelle'" [valueField]="'id'"
            formControlName="modaliteId" [valuePrimitive]="true"></kendo-dropdownlist>
        </div>
        <div class="uk-width-1-2 search-bloc-responsive uk-margin-bottom">
          <input class="full-size" kendoTextBox formControlName="postCode" [(ngModel)]="postCode"
            [placeholder]="'Code postal'" (ngModelChange)="onPostCodeValueChange($event)" />
        </div>
      </div>
      <div class="uk-grid uk-margin-top">
        <div class="uk-width-1-3 search-bloc-responsive uk-margin-bottom">
          <kendo-dropdownlist class="full-size" [data]="listDureeOption" [textField]="'libelle'" [valueField]="'id'"
            formControlName="dureeOptionId" [valuePrimitive]="true" ></kendo-dropdownlist>
        </div>
        <div class="uk-width-1-3 search-bloc-responsive uk-margin-bottom">
          <kendo-datepicker class="full-size" formControlName="dateDebut" placeholder="Date début"></kendo-datepicker>
        </div>
        <div class="uk-width-1-3 search-bloc-responsive uk-margin-bottom">
          <kendo-datepicker class="full-size" formControlName="dateFin" placeholder="Date fin"></kendo-datepicker>
        </div>
      </div>
    </ng-container>
  </div>
</form>
<div class="uk-flex uk-flex-center">
  <button kendoButton type="button" class="colored-text filter-button" (click)="advancedMode = !advancedMode"
    [icon]="advancedMode ? 'minus' : 'plus'">
    {{ advancedMode ? '' : 'Plus de critères' }}
  </button>
</div>
